import {
  XSM_BASE_URL,
  CLIENT_URL,
  REACT_AUTH_ENDPOINT,
  XSM_DOMAIN,
  XSM_APPLICATION,
} from "@/common/constants/auth";
import { getSubdomain } from "@/common/utils/utils";
import { useState, useCallback } from "react";

export const useAuth = () => {
  const subdomain = getSubdomain();
  const [sessionKey, setSessionKey] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const initialAuthorization = useCallback(async (): Promise<string> => {
    if (isLoading) return ""; // Prevent multiple simultaneous calls

    setIsLoading(true);
    setError(null);

    try {
      // Step 1: Call the GET API to authorize and obtain the code
      const response = await fetch(
        `${XSM_BASE_URL}/xsm-api/v1/proxy/oauth2/authorize?response_type=code&client_id=${CLIENT_URL}&redirect_uri=${REACT_AUTH_ENDPOINT}&scope=eves`,
        {
          headers: {
            "Xsm-Domain": subdomain ?? XSM_DOMAIN,
            "xsm-application": XSM_APPLICATION,
          },
        }
      );

      // Step 2: Extract the code from the response URL
      const url = new URL(response.url);
      const sessionDataKey = url.searchParams.get("sessionDataKey");

      if (sessionDataKey) {
        setSessionKey(sessionDataKey);
        setError(null);
        return sessionDataKey;
      } else {
        setError("No session data key received from authorization endpoint");
        return "";
      }
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "Authorization failed";
      setError(errorMessage);
      return "";
    } finally {
      setIsLoading(false);
    }
  }, [subdomain, isLoading]);

  return {
    initialAuthorization,
    sessionKey,
    isLoading,
    error,
  };
};
